import errors from "../errors";
import validate from "../validate";
const { SystemError } = errors;

function modifyOrder(orderId: string, sent: boolean): Promise<void> {
    if (orderId.length !== 24) {
        throw new SystemError("El orderId no tiene la longitud correcta (24 caracteres)");
    }

    validate.token(sessionStorage.token);
    validate.id(orderId, "orderId");

    if (typeof sent !== "boolean") throw new TypeError("Invalid sent value");

    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/orders`, {
        method: "PATCH",
        headers: {
            Authorization: `Bearer ${sessionStorage.token}`,
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ orderId, sent }),
    })
        .catch((error) => {
            throw new SystemError(error.message);
        })
        .then((res) => {
            if (res.status === 204) return;

            return res
                .json()
                .catch((error) => {
                    throw new SystemError(error.message);
                })
                .then((body) => {
                    const { error, message } = body;

                    const Constructor = errors[error as keyof typeof errors];
                    if (Constructor) {
                        throw new Constructor(message);
                    } else {
                        throw new SystemError("Unexpected error occurred");
                    }
                });
        });
}

export default modifyOrder;
